//
//  DSKAcl.ts
//  Supernova SDK
//
//  Created by Miro Koczka.
//
export class SubscriptionProductFeatures {
    constructor(model) {
        this.free = model.free;
        this.team = model.team;
        this.company = model.company;
        this.pro = model.pro;
        this.enterprise = model.enterprise;
    }
}
